import { Link } from 'react-router-dom';

import { Resource } from 'data/nav.data';
import { routes } from 'data/routes';

// Customer Mapper feature disabled for now
// import { NotificationBell } from './components/NotificationBell';
import { SubList } from './components/SubList';

import * as S from './Sidebar.styles';

type SidebarProps = {
  resources: Resource[];
  permissions?: string[];
};

export function Sidebar(props: SidebarProps): React.ReactElement {
  const { resources, permissions = [] } = { ...props };

  // Customer Mapper feature disabled for now
  // const canSeeCustomerMapperNotifications =
  //   permissions.includes('ADMIN') || permissions.includes('CUSTOMER_MAPPER');

  const resourcesMapped = resources?.map((item: Resource) => (
    <S.Li hidden={permissions && !permissions.includes(item.name.toUpperCase())} key={item.id}>
      <S.CategoryTitleRow>
        <S.CategoryTitle
          fontFamily="LFT Zeno Condensed"
          textTransform="uppercase"
          scale="xs"
          color="grayLabel"
          key={item.id}
        >
          {item.name}
        </S.CategoryTitle>

        {/* Customer Mapper feature disabled for now */}
        {/* {item.name === 'Customers' && canSeeCustomerMapperNotifications ? (
          <NotificationBell />
        ) : null} */}
      </S.CategoryTitleRow>

      {item.list && <SubList items={item.list} />}
    </S.Li>
  ));

  return (
    <S.Container>
      <S.Inner>
        <Link to={routes.customers}>
          <S.Title
            fontFamily="LFT Zeno Condensed"
            scale="xl3"
            color="white"
            textTransform="uppercase"
            tag="h2"
          >
            colmar
          </S.Title>
        </Link>

        <S.Ul>{resourcesMapped}</S.Ul>
      </S.Inner>
    </S.Container>
  );
}
